import {UserPermission} from '@cp/model';
import AdminInfoPage from './info/AdminInfoPage';
import AdminJobsPage from './jobs/AdminJobsPage';
import AdminMigrationPage from './migration/AdminMigrationPage';
import AdminModulePage from './module/AdminModulePage';
import AdminModuleViewPage from './moduleView/AdminModuleViewPage';
import AdminQuestionPage from './question/AdminQuestionPage';
import AdminQuestionNewPage from './questionNew/AdminQuestionNewPage';
import AdminQuestionViewPage from './questionView/AdminQuestionViewPage';
import AdminQuestionReviewPage from './questionReview/AdminQuestionReviewPage';
import AdminQuestionReviewQuestionPage from './questionReviewQuestion/AdminQuestionReviewQuestionPage';
import AdminStudyPage from './study/AdminStudyPage';
import AdminSeedQuestionsPage from './seedQuestions/AdminSeedQuestionsPage';
import AdminSeedQuestionPage from './seedQuestion/AdminSeedQuestionPage';
import AdminSeedQuestionImportPage from './seedQuestionImport/AdminSeedQuestionImportPage';
import AdminSeedQuestionOrphanPage from './seedQuestionOrphan/AdminSeedQuestionOrphanPage';
import AdminContactUsPage from './contactUs/AdminContactUsPage';
import AdminDevelopmentPage from './development/AdminDevelopmentPage';
import AdminTradeTagPage from './tradeTag/AdminTradeTagPage';
import AdminTradePage from './trade/AdminTradePage';

export interface AdminTab {
  label: string;
  path: string;
  component: React.ComponentType<any>;
  permission?: UserPermission | UserPermission[];
  group?: string; // Optional group name for grouping related tabs
}

export const adminTabs: AdminTab[] = [
  {
    label: 'Module',
    path: '/admin/module',
    component: AdminModulePage,
    permission: UserPermission.ADMIN,
  },
  {
    label: 'Trades',
    path: '/admin/trades',
    component: AdminTradePage,
    permission: UserPermission.ADMIN,
    group: 'Trade',
  },
  {
    label: 'Trade Tags',
    path: '/admin/tradeTags',
    component: AdminTradeTagPage,
    permission: UserPermission.ADMIN,
    group: 'Trade',
  },
  {
    label: 'Study',
    path: '/admin/study',
    component: AdminStudyPage,
    permission: UserPermission.ADMIN,
  },
  {
    label: 'Question',
    path: '/admin/question',
    component: AdminQuestionPage,
    permission: UserPermission.ADMIN,
    group: 'Question',
  },
  {
    label: 'Question Review',
    path: '/admin/questionReview',
    component: AdminQuestionReviewPage,
    permission: [UserPermission.ADMIN, UserPermission.REVIEWER],
    group: 'Question',
  },
  {
    label: 'Jobs',
    path: '/admin/jobs',
    component: AdminJobsPage,
    permission: UserPermission.ADMIN,
    group: 'Internal',
  },
  {
    label: 'Migration',
    path: '/admin/migration',
    component: AdminMigrationPage,
    permission: UserPermission.ADMIN,
    group: 'Internal',
  },
  {
    label: 'Development',
    path: '/admin/development',
    component: AdminDevelopmentPage,
    permission: UserPermission.ADMIN,
    group: 'Internal',
  },
  {
    label: 'Info',
    path: '/admin/info',
    component: AdminInfoPage,
    permission: UserPermission.ADMIN,
    group: 'Internal',
  },
  {
    label: 'Contact Us',
    path: '/admin/contactUs',
    component: AdminContactUsPage,
    permission: UserPermission.ADMIN,
    group: 'Internal',
  },
  // Parameterized routes
  {
    label: 'Module View',
    path: '/admin/module/:id',
    component: AdminModuleViewPage,
    permission: UserPermission.ADMIN,
  },
  {
    label: 'Question Review Question',
    path: '/admin/questionReview/:questionId',
    component: AdminQuestionReviewQuestionPage,
    permission: [UserPermission.ADMIN, UserPermission.REVIEWER],
  },
  {
    label: 'Question View',
    path: '/admin/question/:questionId',
    component: AdminQuestionViewPage,
    permission: UserPermission.ADMIN,
  },
  {
    label: 'Question New',
    path: '/admin/question/new',
    component: AdminQuestionNewPage,
    permission: UserPermission.ADMIN,
    group: 'Question',
  },
  {
    label: 'Seed Questions',
    path: '/admin/seedQuestions',
    component: AdminSeedQuestionsPage,
    permission: UserPermission.ADMIN,
    group: 'Seed Question',
  },
  {
    label: 'Seed Question View',
    path: '/admin/seedQuestion/:seedQuestionId',
    component: AdminSeedQuestionPage,
    permission: UserPermission.ADMIN,
  },
  {
    label: 'Seed Question Import',
    path: '/admin/seedQuestion/import',
    component: AdminSeedQuestionImportPage,
    permission: UserPermission.ADMIN,
    group: 'Seed Question',
  },
  {
    label: 'Seed Question Orphan',
    path: '/admin/seedQuestionOrphan',
    component: AdminSeedQuestionOrphanPage,
    permission: UserPermission.ADMIN,
    group: 'Seed Question',
  },
];
